import Breadcrumb from '@stories/Components/Breadcrumb/Breadcrumb';
import React from 'react';
import S from './NewsArticleHero.styles';
import { Device, until } from '@helpers/media';
import { responsiveSizes } from '@helpers/responsive';
const NewsArticleHero = ({ author, breadcrumb, image, imageMode = 'cover', logoIcon, tag, title, }) => {
    const imageSettings = {
        width: 960,
    };
    return (React.createElement(S.Container, { "data-image": !!image, flush: "top" },
        React.createElement(S.Inner, null,
            breadcrumb?.length && (React.createElement(S.BreadcrumbWrapper, null,
                React.createElement(Breadcrumb, { items: breadcrumb }))),
            React.createElement(S.ContentWrapper, null,
                tag && React.createElement(S.PreTitle, null, tag),
                React.createElement(S.Title, null, title),
                author && React.createElement(S.Author, null, author)),
            image && (React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { image: image, imageMode: imageMode, imageProps: imageSettings, sizes: [`${until(Device.Tablet)} 100vw`, `50vw`].join(', '), srcSet: responsiveSizes([{ value: 100, breakpoint: Device.Tablet }, { value: 50 }], image, { heightRatio: 566 / 943, mode: 'crop' }) })))),
        !image && (React.createElement(S.LogoIcon, { alt: logoIcon && logoIcon.title, loading: "lazy", src: logoIcon && logoIcon.icon }))));
};
export default NewsArticleHero;
